import { CalendarIcon, Clock } from "lucide-react";
import { format, parseISO } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const TIMES = (() => {
  const out = [];
  for (let h = 8; h <= 23; h++) {
    for (const m of [0, 30]) {
      const hh = String(h).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      const ap = h < 12 ? "AM" : "PM";
      const h12 = h % 12 === 0 ? 12 : h % 12;
      out.push({ value: `${hh}:${mm}`, label: `${h12}:${mm} ${ap}` });
    }
  }
  return out;
})();

const trigger = "w-full h-12 mt-1 rounded-xl border border-border bg-background px-3 text-base flex items-center gap-2 outline-none focus:border-primary data-[state=open]:border-primary";

export function DateTimeFields({ date, time, minDate, maxDate, bookedOutDates = [], onDateChange, onTimeChange }) {
  const selected = date ? parseISO(date) : undefined;
  const minD = minDate ? parseISO(minDate) : undefined;
  const maxD = maxDate ? parseISO(maxDate) : undefined;
  const disabled = [
    ...(minD ? [{ before: minD }] : []),
    ...(maxD ? [{ after: maxD }] : []),
    ...bookedOutDates.map((d) => parseISO(d)),
  ];

  return (
    <div className="flex gap-3">
      <div className="flex-1 min-w-0">
        <label className="text-xs text-muted-foreground">Event date</label>
        <Popover>
          <PopoverTrigger asChild>
            <button type="button" data-testid="booking-date" className={trigger}>
              <CalendarIcon className="w-4 h-4 text-primary shrink-0" />
              <span className={`truncate ${date ? "" : "text-muted-foreground"}`}>
                {selected ? format(selected, "EEE, d MMM yyyy") : "Choose date"}
              </span>
            </button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              selected={selected}
              defaultMonth={selected || minD}
              onSelect={(d) => d && onDateChange(format(d, "yyyy-MM-dd"))}
              disabled={disabled.length ? disabled : undefined}
              initialFocus
            />
          </PopoverContent>
        </Popover>
      </div>
      <div className="flex-1 min-w-0">
        <label className="text-xs text-muted-foreground">Time</label>
        <Select value={time} onValueChange={onTimeChange}>
          <SelectTrigger data-testid="booking-time" className={trigger}>
            <Clock className="w-4 h-4 text-primary shrink-0" />
            <SelectValue placeholder="Time" />
          </SelectTrigger>
          <SelectContent className="max-h-64">
            {TIMES.map((t) => (
              <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
